module.exports = __webpack_public_path__ + "static/media/IS.153ad49c.svg";